import { map, toPairs, join, compose, equals, pathOr } from 'ramda';
import modes from '../modes';

export const makeParams = compose(
  join('&'),
  map(([key, value]) => `${key}=${value}`),
  toPairs,
);
export const makeURLWithParams = (url, params) => `${url}?${makeParams(params)}`;

export const getUrlGoogleMaps = key =>
  `https://maps.googleapis.com/maps/api/js?v=3.48&key=${key}&v=3&libraries=geometry,places`;

export const isInIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

export const isMainMode = mode => equals(mode, modes.MAIN);

export const getGAMID = () => pathOr('', ['tarteaucitron', 'user', 'gtagUa'], window);
